import { GrackleLogo, Notice } from "../components/ui";
import { useSession } from "../session";

/**
 * `/extension-bridge` — a same-origin page the Chrome extension can open (or keep in a
 * background tab) so cookie-authenticated `/api/v1` calls run as first-party fetches.
 *
 * FR-X6: no API key is minted here. The extension never stores a long-lived secret; it
 * borrows the Grackle web session. FR-X5: only the Grackle host is involved.
 */
export default function ExtensionBridge() {
  const { user, orgs, loading } = useSession();

  return (
    <div className="auth-page">
      <div className="auth-card">
        <GrackleLogo />
        <div className="auth-heading">
          <h1>Extension connected</h1>
          <p>
            This tab is the session bridge for the Grackle Chrome extension. Leave it open while
            you record a Meet so uploads can use your existing sign-in.
          </p>
        </div>
        {loading ? (
          <Notice>Checking your session…</Notice>
        ) : user ? (
          <Notice>
            Signed in as {user.name} ({user.email})
            {orgs.length > 0 ? ` · ${orgs.length} org${orgs.length === 1 ? "" : "s"}` : ""}.
            You can return to the Meet tab and start recording.
          </Notice>
        ) : (
          <Notice tone="error">
            You are not signed in. Open{" "}
            <a href="/signin">Sign in</a> in this browser, then come back here.
          </Notice>
        )}
      </div>
    </div>
  );
}
